<calao-slidebox [componentId]="componentId" [dataTemplate]="slideboxData"></calao-slidebox>